import React from 'react';
import './Fbplastic.css';
import FBPlaten from '../../../imgs/FBPlaten.webp'; 

const Fbplastic = () => {
  return (
    <div className="Fbplast-container"data-aos="fade-down" >
      <img src={FBPlaten} alt="Fitting Corrosion" className="Fbplast-image" />
    </div>
  );
};

export default Fbplastic;
